<template>
	<div class="kova-lp-marquee">
		<div class="kova-lp-marquee__track">
			<!-- The run is rendered twice so the track can loop by exactly one run
			     width; the copy is decorative and hidden from assistive tech. -->
			<div v-for="pass in 2" :key="pass" :aria-hidden="pass === 2 || undefined" class="kova-lp-marquee__run">
				<slot />
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'LandingKovaMarquee',
}
</script>

<style lang="scss" scoped>
// A seamless ticker. Consumers set the three custom properties from their own
// scoped styles — custom properties inherit through the scoped boundary — and put
// their block class on this root to reach `mask-image` directly.
.kova-lp-marquee {
	overflow: hidden;

	--kova-lp-marquee-gap: var(--size-20);
	--kova-lp-marquee-duration: 40s;
	--kova-lp-marquee-fade: var(--size-24);

	mask-image: linear-gradient(
		to right,
		transparent,
		#000 var(--kova-lp-marquee-fade),
		#000 calc(100% - var(--kova-lp-marquee-fade)),
		transparent
	);
}

.kova-lp-marquee__track {
	display: flex;
	width: max-content;

	animation: kova-lp-marquee-scroll var(--kova-lp-marquee-duration) linear infinite;
}

// Holds the strip so a card can actually be read.
.kova-lp-marquee:hover .kova-lp-marquee__track,
.kova-lp-marquee:focus-within .kova-lp-marquee__track {
	animation-play-state: paused;
}

// The gap doubles as the run's leading pad, so the two runs meet at exactly the
// item spacing and the -50% loop lands seamlessly. A track-level gap would not:
// it would add half a gap to the travel and the strip would drift each cycle.
.kova-lp-marquee__run {
	display: flex;
	flex-shrink: 0;
	gap: var(--kova-lp-marquee-gap);
	padding-left: var(--kova-lp-marquee-gap);
}

@keyframes kova-lp-marquee-scroll {
	to {
		transform: translateX(-50%);
	}
}

@media (prefers-reduced-motion: reduce) {
	.kova-lp-marquee__track {
		animation: none;
	}
}
</style>
